import classNames from 'classnames'
import Icon from 'common/Icon'
import BaseButton from 'common/BaseButton'
import 'react-toastify/dist/ReactToastify.css'
import styles from './index.module.scss'

type SuccessBannerProps = {
  message: string
  isRedesign?: boolean
  closeToast?: () => void
}

const SuccessBanner: React.FC<SuccessBannerProps> = ({
  message,
  isRedesign,
  closeToast,
}) =>
  isRedesign ? (
    <div className={classNames(styles.success_banner_new, '~font-roboto')}>
      <Icon
        icon="circleCheck"
        className={styles.email_sent_icon}
        fill={`#2BB673`}
      />
      <div className={`${styles.message}`}>{message}</div>
    </div>
  ) : (
    <div
      className={classNames(
        styles.banner_container,
        styles.success_banner,
        '~font-roboto ~flex ~items-center ~justify-between'
      )}
    >
      <div className="~text-white">{message}</div>
      <BaseButton onClick={closeToast} aria-label="Close">
        <Icon icon="close" fill="white" className="fa-lg" />
      </BaseButton>
    </div>
  )

export default SuccessBanner
